module.exports = __webpack_public_path__ + "static/media/main-img1.55857530.png";